import './Products.css';

const CATEGORIES = [
  {
    icon: '🏅',
    title: 'Goudstaven',
    desc: 'Wij kopen beleggingsgoudstaven aan van alle toonaangevende raffinaderijen: Valcambi, EMEKO, C. Hafner, Umicore en Metalor.',
    items: ['5g – 1kg staven', 'LBMA gecertificeerd', '999.9 fijnheid', 'Met echtheidscertificaat'],
  },
  {
    icon: '🪙',
    title: 'Goudmunten',
    desc: 'Wij kopen wereldwijd erkende gouden beleggingsmunten aan, geprijsd op basis van hun zuivere goudgewicht.',
    items: ['Krugerrand', 'Maple Leaf', 'Vienna Philharmonic', 'American Eagle', 'Britannia', 'Sovereign'],
  },
  {
    icon: '⬜',
    title: 'Zilver',
    desc: 'Wij kopen zilverstaven en -munten aan tegen een transparante prijs op basis van de live spotkoers.',
    items: ['100g – 5kg staven', 'Zilver Maple Leaf', 'Zilver Eagle', 'Vienna Philharmonic'],
  },
  {
    icon: '💍',
    title: 'Sloopgoud',
    desc: 'Wij kopen oud goud aan: juwelen, tanden, elektronica. Eerlijke prijs op basis van live spotkoers.',
    items: ['8k tot 24k goud', 'Directe uitbetaling', 'Gratis schatting', 'Discreet & betrouwbaar'],
  },
];

export function Products() {
  return (
    <section id="products" className="products">
      <div className="products__container">
        <h2 className="products__title">Wat Wij Aankopen</h2>
        <p className="products__subtitle">Deze edelmetalen kopen wij aan tegen de live spotkoers</p>
        <div className="products__grid">
          {CATEGORIES.map(cat => (
            <div key={cat.title} className="product-card">
              <div className="product-card__icon">{cat.icon}</div>
              <h3 className="product-card__title">{cat.title}</h3>
              <p className="product-card__desc">{cat.desc}</p>
              <ul className="product-card__list">
                {cat.items.map(item => (
                  <li key={item} className="product-card__item">
                    <span className="product-card__check">✓</span> {item}
                  </li>
                ))}
              </ul>
              <a href="#contact" className="btn btn--outline btn--sm">Prijs aanvragen</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
